import React from 'react';
import Snackbar from '@mui/material/Snackbar';

const SnackbarComponent = ({ snackbarState, setSnackbarState }) => {
    const handleSnackbarClose = () => {
        setSnackbarState({ ...snackbarState, open: false, message: "" });
    };

    return (
        <Snackbar
            autoHideDuration={3000}
            open={snackbarState.open}
            onClose={handleSnackbarClose}
            message={snackbarState.message}
            anchorOrigin={{
                vertical: "top",
                horizontal: "center"
            }}
        />
    );
};

export default SnackbarComponent;